/* Bundle maison — Soutien-gorge Aline, Sovamia (clone de l'offre « Køb flere og spar MERE! »).
   4 paliers : 1 · 1+1 · 2+2 · 3+4. Chaque soutien-gorge a SA couleur ET SA taille.
   Une ligne de panier par unité, envoyée en un seul appel /cart/add.js, puis le TIROIR DU THÈME.
   Les prix des paliers sont tenus par 3 remises automatiques en montant fixe (dès 2 / 4 / 7). */
(function () {
  const racine = document.querySelector('[data-sgb]');
  if (!racine) return;
  const conf = JSON.parse(racine.querySelector('[data-sgb-config]').textContent);
  const T = conf.textes;
  const bouton = racine.querySelector('[data-sgb-add]');
  const erreur = racine.querySelector('[data-sgb-err]');
  const nomCouleur = racine.querySelector('[data-sgb-cname]');
  let palier = conf.paliers.find((p) => p.defaut) || conf.paliers[0];
  let enCours = false;

  /* le prix s'écrit au format de la boutique ({{amount}} $ → point décimal) */
  const argent = (c) => {
    const n = (c / 100).toFixed(2);
    const virgule = /comma_separator/.test(conf.format);
    return conf.format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, virgule ? n.replace('.', ',') : n);
  };
  const variante = (c, t) => conf.variantes.find((v) => v.c === c && v.t === t);
  const pastille = (c) => (conf.couleurs.find((x) => x.nom === c) || conf.couleurs[0]).img;

  /* choix[i] = { c: couleur, t: taille ('' tant que non choisie) } */
  const MAX = Math.max.apply(null, conf.paliers.map((p) => p.qte));
  const choix = [];
  for (let i = 0; i < MAX; i++) choix.push({ c: conf.couleurs[0].nom, t: '', tAuto: true });

  /* ───────── la galerie suit la couleur du soutien-gorge n° 1 (picker natif masqué) */
  function coche(valeur) {
    const zone = document.querySelector('variant-selects, variant-radios');
    if (!zone || !valeur) return;
    const r = zone.querySelector('input[type="radio"][value="' + CSS.escape(valeur) + '"]');
    if (r) { if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } return; }
    zone.querySelectorAll('select').forEach((s) => {
      if (s.value !== valeur && [...s.options].some((o) => o.value === valeur)) {
        s.value = valeur; s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ───────── les lignes de choix d'un palier : vignette + couleur + taille */
  function optionsTailles(sel) {
    let h = '<option value="">' + T.taille + '</option>';
    conf.bandes.forEach((b) => {
      h += '<optgroup label="' + T.bande + ' ' + b + '">';
      conf.tailles.filter((t) => t.indexOf(b) === 0).forEach((t) => {
        h += '<option value="' + t + '"' + (t === sel ? ' selected' : '') + '>' + t + '</option>';
      });
      h += '</optgroup>';
    });
    return h;
  }
  function dessine(p) {
    const zone = racine.querySelector('[data-sgb-tier="' + p.cle + '"] [data-sgb-units]');
    let h = '<p class="sgb__ulbl">' + T.entete + '</p>';
    for (let i = 0; i < p.qte; i++) {
      const u = choix[i];
      h += '<div class="sgb__u" data-i="' + i + '"><span class="sgb__n">' + (i + 1) + '</span>' +
        '<img class="sgb__thumb" src="' + pastille(u.c) + '" alt="" width="40" height="40" loading="lazy">' +
        '<span class="sgb__sel"><select data-k="c" aria-label="' + T.couleur + ' ' + (i + 1) + '">' +
        conf.couleurs.map((c) => '<option' + (c.nom === u.c ? ' selected' : '') + '>' + c.nom + '</option>').join('') +
        '</select></span><span class="sgb__sel sgb__sel--t"><select data-k="t" aria-label="' + T.taille + ' ' + (i + 1) + '">' +
        optionsTailles(u.t) + '</select></span></div>';
    }
    zone.innerHTML = h;
  }
  racine.addEventListener('change', (e) => {
    const s = e.target.closest('.sgb__u select'); if (!s) return;
    const i = +s.closest('.sgb__u').dataset.i, k = s.dataset.k;
    choix[i][k] = s.value;
    if (k === 't') {
      choix[i].tAuto = false;
      s.closest('.sgb__sel').classList.remove('est-erreur');
      /* confort : les tailles encore vides prennent celle-ci */
      for (let j = 0; j < MAX; j++) if (j !== i && choix[j].tAuto) choix[j].t = s.value;
      erreur.classList.remove('est-visible');
    }
    if (k === 'c' && i === 0) { majCouleurHaut(s.value); coche(s.value); }
    if (k === 'c') s.closest('.sgb__u').querySelector('.sgb__thumb').src = pastille(s.value);
    if (k === 't') dessine(palier);
  });

  /* ───────── les pastilles du haut : changent la couleur de TOUS les soutiens-gorge */
  function majCouleurHaut(c) {
    if (nomCouleur) nomCouleur.textContent = c;
    racine.querySelectorAll('[data-sgb-sw]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.sgbSw === c ? 'true' : 'false'));
  }
  racine.querySelectorAll('[data-sgb-sw]').forEach((b) => b.addEventListener('click', () => {
    const c = b.dataset.sgbSw;
    choix.forEach((u) => { u.c = c; });
    majCouleurHaut(c); coche(c); dessine(palier);
  }));

  /* ───────── les paliers */
  function choisit(p) {
    palier = p;
    racine.querySelectorAll('[data-sgb-tier]').forEach((t) => {
      const ok = t.dataset.sgbTier === p.cle;
      t.classList.toggle('est-choisi', ok);
      t.setAttribute('aria-checked', ok ? 'true' : 'false');
      t.querySelector('[data-sgb-units]').hidden = !ok;
    });
    dessine(p);
    erreur.classList.remove('est-visible');
    const tete = document.querySelector('[data-sga-prix]');
    if (tete) tete.textContent = argent(p.total);
    bouton.querySelector('[data-sgb-lbl]').textContent = T.ajouter;
  }
  racine.querySelectorAll('[data-sgb-tier]').forEach((t) => {
    t.addEventListener('click', (e) => {
      if (e.target.closest('.sgb__u')) return;
      const p = conf.paliers.find((x) => x.cle === t.dataset.sgbTier);
      if (p !== palier) choisit(p);
    });
    t.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('.sgb__u')) { e.preventDefault(); t.click(); }
    });
  });

  /* ───────── ajout au panier */
  bouton.addEventListener('click', async () => {
    if (enCours) return;
    const n = palier.qte, items = [];
    let premier = null;
    for (let i = 0; i < n; i++) {
      const row = racine.querySelector('[data-sgb-tier="' + palier.cle + '"] .sgb__u[data-i="' + i + '"]');
      if (!choix[i].t) {
        row.querySelector('.sgb__sel--t').classList.add('est-erreur');
        if (!premier) premier = row.querySelector('[data-k="t"]');
      }
    }
    if (premier) {
      erreur.textContent = n === 1 ? T.manque1 : T.manque;
      erreur.classList.add('est-visible');
      premier.focus({ preventScroll: true });
      premier.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    for (let i = 0; i < n; i++) {
      const v = variante(choix[i].c, choix[i].t);
      if (!v) { erreur.textContent = T.indispo.replace('{n}', i + 1); erreur.classList.add('est-visible'); return; }
      const props = {}; props[T.eu] = conf.eu[choix[i].t]; props._lot = palier.cle;
      items.push({ id: v.id, quantity: 1, properties: props });
    }
    erreur.classList.remove('est-visible');
    enCours = true; bouton.disabled = true;
    const lbl = bouton.querySelector('[data-sgb-lbl]'); lbl.textContent = T.en_cours;
    try {
      const drawer = document.querySelector('cart-drawer');
      const corps = { items: items.slice().reverse() };  // la dernière ajoutée s'affiche en premier
      if (drawer && drawer.getSectionsToRender) {
        corps.sections = drawer.getSectionsToRender().map((s) => s.id);
        corps.sections_url = window.location.pathname;
      }
      const rep = await fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps) });
      if (!rep.ok) throw new Error('ajout refusé');
      const data = await rep.json();
      if (drawer && drawer.renderContents) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (drawer.open) drawer.open();      // renderContents n'ouvre pas le tiroir tout seul
      } else {
        window.location.href = (window.routes ? window.routes.cart_url : '/cart');
        return;
      }
      if (window.publish && window.PUB_SUB_EVENTS) {
        const panier = await (await fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')).json();
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sgb', cartData: panier });
      }
    } catch (e) {
      window.location.href = (window.routes ? window.routes.cart_url : '/cart');
    } finally {
      enCours = false; bouton.disabled = false; lbl.textContent = T.ajouter;
    }
  });

  /* ───────── guide des tailles : la modale sort dans <body> (un parent transformé casse le fixed) */
  const guide = racine.querySelector('[data-sgb-modal]');
  if (guide) {
    document.body.appendChild(guide);
    const ouvre = () => { guide.hidden = false; document.documentElement.style.overflow = 'hidden'; };
    const ferme = () => { guide.hidden = true; document.documentElement.style.overflow = ''; };
    racine.querySelectorAll('[data-sgb-guide]').forEach((b) => b.addEventListener('click', ouvre));
    document.querySelectorAll('[data-sga-guide]').forEach((b) => b.addEventListener('click', ouvre));
    guide.addEventListener('click', (e) => { if (e.target === guide || e.target.closest('[data-sgb-close]')) ferme(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !guide.hidden) ferme(); });
  }

  /* ───────── barre collante : visible quand le bouton principal sort de l'écran */
  const barre = document.querySelector('[data-sga-stick]');
  if (barre) {
    document.body.appendChild(barre);
    barre.querySelector('button').addEventListener('click', () => bouton.click());
    new IntersectionObserver((es) => {
      barre.classList.toggle('est-visible', !es[0].isIntersecting);
    }).observe(bouton);
  }

  /* départ */
  majCouleurHaut(choix[0].c);
  choisit(palier);
})();
